module.exports = __webpack_public_path__ + "static/media/FoodTrak.7ebb3702.jpeg";